(ns livefeed.moderation
  (:require [reagent.core :as reagent]))

(defonce comments-in-moderation (reagent/atom []))

(defn add-to-moderation! [comment]
  (swap! comments-in-moderation conj comment))

(defn comment-moderated! [comment]
  (swap! comments-in-moderation (partial filter #(not= (:content comment) (:content %)))))
